const name = 'table-component';

export const GET_TABLE_DATA_REQUEST = `${name}/GET_TABLE_DATA_REQUEST`;
export const GET_TABLE_DATA_SUCCESS = `${name}/GET_TABLE_DATA_SUCCESS`;
export const GET_TABLE_DATA_FAILURE = `${name}/GET_TABLE_DATA_FAILURE`;

export const GET_TABLE_CONFIGURATION_REQUEST = `${name}/GET_TABLE_CONFIGURATION_REQUEST`;
export const GET_TABLE_CONFIGURATION_SUCCESS = `${name}/GET_TABLE_CONFIGURATION_SUCCESS`;
export const GET_TABLE_CONFIGURATION_FAILURE = `${name}/GET_TABLE_CONFIGURATION_FAILURE`;

export const UPDATE_TABLE_ROW_REQUEST = `${name}/UPDATE_TABLE_ROW_REQUEST`;
export const UPDATE_TABLE_ROW_SUCCESS = `${name}/UPDATE_TABLE_ROW_SUCCESS`;
export const UPDATE_TABLE_ROW_FAILURE = `${name}/UPDATE_TABLE_ROW_FAILURE`;

export const CREATE_TABLE_ROW_REQUEST = `${name}/CREATE_TABLE_ROW_REQUEST`;
export const CREATE_TABLE_ROW_SUCCESS = `${name}/CREATE_TABLE_ROW_SUCCESS`;
export const CREATE_TABLE_ROW_FAILURE = `${name}/CREATE_TABLE_ROW_FAILURE`;

export const DELETE_TABLE_ROW_REQUEST = `${name}/DELETE_TABLE_ROW_REQUEST`;
export const DELETE_TABLE_ROW_SUCCESS = `${name}/DELETE_TABLE_ROW_SUCCESS`;
export const DELETE_TABLE_ROW_FAILURE = `${name}/DELETE_TABLE_ROW_FAILURE`;

export default name;
